import * as React from "react";

function IcProductFlightFill(props) {
  const {
    accentColor: accent = "#0194F3",
    color = "#687176",
    width = 24,
    height = 24,
    title,
    titleId,
  } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-id="IcProductFlightFill"
      aria-labelledby={titleId}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.24315 18.6215C4.14242 19.2723 4.72762 19.8576 5.37843 19.7568L6.5885 22.177C6.82109 22.6422 7.37143 22.8514 7.85432 22.6582L8.06676 22.5733C8.91113 22.2355 9.42133 21.3706 9.30853 20.4682L9 18L13.2857 14.4285L18.5103 22.2654C18.7901 22.6851 19.3385 22.8307 19.7896 22.6052L20.2243 22.3878C20.6694 22.1653 20.8831 21.6493 20.7257 21.1772L19 16L19.7929 15.2071C20.1834 14.8165 20.1834 14.1834 19.7929 13.7929L19.2071 13.2071C18.8837 12.8837 18.394 12.8281 18.0134 13.0402L17.1493 10.4477L21.8613 4.85215C22.5053 4.08738 22.457 2.95695 21.75 2.24997C21.043 1.54298 19.9126 1.49463 19.1478 2.13865L13.5522 6.85071L10.9597 5.98654C11.1719 5.60596 11.1163 5.11623 10.7929 4.79286L10.2071 4.20707C9.81658 3.81655 9.18342 3.81655 8.79289 4.20707L8 4.99997L2.82279 3.27423C2.35068 3.11686 1.83469 3.33059 1.61213 3.7757L1.39479 4.21038C1.16925 4.66146 1.3149 5.2099 1.73452 5.48965L9.57143 10.7143L6 15L3.53173 14.6914C2.62934 14.5786 1.76445 15.0888 1.4267 15.9332L1.34173 16.1456C1.14857 16.6285 1.35781 17.1789 1.82299 17.4115L4.24315 18.6215Z"
        fill="#30C5F7"
      />
    </svg>
  );
}

export default IcProductFlightFill;
